<template>
    <v-container fluid fill-height pa-0 class="overlay">
        <div class="main-container pa-6">
            <v-flex text-center>
                <v-img
                    :src="require('@/assets/images/error.svg')"
                    class="d-inline-flex mb-8"
                ></v-img>
                <div class="common-text text-center">
                    Увы, но данным сайтом можно пользоваться только на телефоне
                </div>
            </v-flex>
        </div>
    </v-container>
</template>

<script>
export default {
  name: 'DesktopPage',
  data() {
    return {
      truth: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.overlay {
    z-index: 100;
    position: absolute;
    background: #FFFFFF;

    .main-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
}
</style>
